<template lang="pug">
SideOverlaySlot(
  :isOpen="isOpen",
  title="EDIT"
  @closeOverlay="closeOverlay"
)
  template(#contentTop)
    .form-group
      label(for="patient-navigation-name") Entry Name (Required)
      input#patient-navigation-name(type="text" v-model="patientNavigationSetting.name")
  template(#footer)
    .flex.flex--space-between
      BaseBtn.x-lg.red-outline(
        href="#",
        @click.prevent="closeOverlay"
      ) CANCEL
      BaseBtn.x-lg.green(
        @click="updatePatientNavigationSettingEntry"
        :disabled="!patientNavigationSetting.name"
      ) CONTINUE
</template>

<script>
import { defineComponent } from "vue";
import SideOverlaySlot from "@/components/overlays/SideOverlaySlot.vue";
import {
  fetchPatientNavigationSetting,
  updatePatientNavigationSetting,
} from "@/api/patientNavigationSettingsApi";

export default defineComponent({
  components: { SideOverlaySlot },
  emits: ["closeManagePatientNavigationSettingOverlay"],
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      patientNavigationSetting: {
        name: "",
      },
    };
  },
  methods: {
    closeOverlay() {
      this.patientNavigationSetting = { name: "" };
      this.$emit("closeManagePatientNavigationSettingOverlay");
    },
    async loadPatientNavigationSetting() {
      this.patientNavigationSetting = { name: "" };
      if (this.id === null || this.id === undefined) return;
      try {
        const response = await fetchPatientNavigationSetting(String(this.id));
        this.patientNavigationSetting = {
          ...response.data.patientNavigationSetting,
        };
      } catch (error) {
        console.log(error);
      }
    },
    async updatePatientNavigationSettingEntry() {
      if (!this.patientNavigationSetting.name) return;
      try {
        await updatePatientNavigationSetting(String(this.id), {
          patientNavigationSetting: {
            ...this.patientNavigationSetting,
          },
        });
        this.closeOverlay();
      } catch (error) {
        console.log(error);
      }
    },
  },
  watch: {
    id: {
      handler() {
        this.loadPatientNavigationSetting();
      },
      immediate: true,
    },
  },
});
</script>

<style scoped lang="scss"></style>
